import { render, staticRenderFns } from "./DebtorsChipPopup.vue?vue&type=template&id=0059fd4a&scoped=true&"
import script from "./DebtorsChipPopup.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DebtorsChipPopup.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DebtorsChipPopup.vue?vue&type=style&index=0&id=0059fd4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059fd4a",
  null
  
)

export default component.exports